export default __webpack_public_path__ + "static/bg-body-d9d94457e92e19329d9ac2605a1cdf3e.jpg";